import endpoints from "../core/endpoints";
import request from "../core/request";

export const getProjects = async () => {
  const { data } = await request.get(endpoints.project.list);
  return data;
};
